// extracted by mini-css-extract-plugin
export default {"root":"Price__root___CgvEU"};